const FILE_TYPE_LABELS: Record<string, string> = {
  txt: 'Text file',
  pdf: 'PDF document',
  csv: 'CSV file',
  json: 'JSON file',
  xml: 'XML file',
  zip: 'Zip archive',
  xls: 'Excel spreadsheet',
  xlsx: 'Excel spreadsheet',
  doc: 'Word document',
  docx: 'Word document',
  png: 'PNG image',
  jpg: 'JPEG image',
  jpeg: 'JPEG image',
};

export const getFileTypeLabel = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  return FILE_TYPE_LABELS[ext] ?? 'File';
};
